import firebase from 'firebase';
const config = {
        apiKey: "AIzaSyDq8HRDCRbu4ypaSFXcZsZX-1wNnLaavbw",
        authDomain: "fire-intro-rlefvers.firebaseapp.com",
        databaseURL: "https://fire-intro-rlefvers.firebaseio.com",
        projectId: "fire-intro-rlefvers",
        storageBucket: "fire-intro-rlefvers.appspot.com",
        messagingSenderId: "1051440508412"
    };
var fire = firebase.initializeApp(config);
export default fire;

